import {base64StringToBlob} from 'blob-util';
import { Modal } from 'bootstrap';
import {saveAs} from 'file-saver';
import naja from 'naja';

interface FileJson {
    name: string;
    data: string;
}

export default class DownloadDialog {
    private modalActive: boolean = true;
    private readonly maxRetries: number = 3;
    private retryCount: number = 0;
    private retryDelay: number = 5000;

    public constructor(element: Element) {
        const url = element.getAttribute('data-download-url');

        if (url === null) {
            throw new Error('There is no download url specified');
        }

        const modal = element.closest('.modal');

        if (modal === null) {
            throw new Error('Download dialog does not have .modal parent');
        }

        naja.addEventListener('before', function(event) {
            // @ts-ignore
            naja.removeEventListener('before', this);

            modal.addEventListener('hide.bs.modal', function() {
                // @ts-ignore
                modal.removeEventListener('hide.bs.modal', this);

                event.xhr.abort();
            });
        });

        this.makeRequestWithRetry(url, modal);
    }

    private makeRequestWithRetry(url: string, modal: Element): void {
        naja.makeRequest('GET', url)
            .then(response => {
                if (this.modalActive && 'file' in response) {
                    const file = (response as {file: FileJson}).file;
                    saveAs(base64StringToBlob(file.data), file.name);
                }
            }).catch((error) => {
                if (this.isTimeout(error) && this.retryCount < this.maxRetries) {
                    this.retryCount++;
                    setTimeout(() => {
                        this.makeRequestWithRetry(url, modal);
                    }, this.retryDelay * this.retryCount);
                } else {
                    new Modal(modal as HTMLElement).hide();
                }
            });
    }

    private isTimeout(error: any): boolean {
        return error
            && (error.status === 408
                || error.timeout === true
                || error.message?.includes('timeout')
                || error.code === 'ECONNABORTED'
            );
    }
}
